import React from 'react';
import { Card, Checkbox } from 'semantic-ui-react';
import styled from 'styled-components';

import { Service } from '@/types/service';

export type Props = {
  values: number[];
  list: Service[];
  onChange: (serviceId: number, checked: boolean) => void;
};

export const Checkboxes: React.FC<Props> = ({ values, list, onChange }) => (
  <Styled>
    <div className="services">
      <Card.Group className="service-cards">
        {list.map((item, i) => (
          <label
            data-test={`service-${i}`}
            htmlFor={`service-${item.id}`}
            key={item.id}
            className="service-label"
          >
            <Card
              className={
                values.includes(item.id)
                  ? 'service-card active'
                  : 'service-card'
              }
            >
              <Card.Content className="service-grid">
                <Checkbox
                  checked={values.includes(item.id)}
                  id={`service-${item.id}`}
                  onChange={(e, data) => {
                    onChange(item.id, !!data.checked);
                  }}
                />
                <Card.Header>{item.name}</Card.Header>
                <Card.Meta>{item.subtitle}</Card.Meta>
              </Card.Content>
            </Card>
          </label>
        ))}
      </Card.Group>
    </div>
  </Styled>
);

const Styled = styled.div`
  .ui.cards.service-cards {
    padding-bottom: 1.75em;
  }

  .ui.cards.service-cards > label {
    width: 100% !important;
    margin-bottom: 0 !important;
    cursor: pointer;
  }

  .ui.cards .ui.card.service-card {
    width: auto;
    margin: 0.875em 0.75em 0 !important;
    border: 1px solid transparent;
  }

  .service-grid > .checkbox {
    display: block;
    margin: 1em 1.25em 1em 0.5em;
    float: left;
  }

  .service-grid .header {
    margin: 0.15em 0 0.25em !important;
  }

  .ui.card.active {
    border: 1px solid #2185d0;
    background-color: #f1f9ff;
  }
`;
